import { notification } from 'antd';
import { action, observable } from 'mobx';
import { requestStore } from './requestStore';

export class TokenStore {
    @observable
    token: string | null = '';

    @observable
    autenticado: boolean = false;

    @observable
    usuario: string | null = '';

    @observable
    password: string | null = '';

    @observable
    username: string | null = '';

    @observable
    email: string | null = '';

    @action
    async getToken() {
        const usuarioEnviar = this.usuario != null ? this.usuario : '';
        const passwordEnviar = this.password != null ? this.password : '';
        const response = await requestStore.getToken(usuarioEnviar, passwordEnviar);
        if (response) {
            switch (response) {
                case 'incorrecto':
                    this.muestraMensajeError('usuario y/o contraseña no son validos');
                    break;
                case 'expiro':
                    break;
                case 'vacio':
                    this.muestraMensajeError('usuario y/o contraseña no pueden ser vacios');
                    break;
                case 'indefinido':
                    this.muestraMensajeError(response);
                    break;
                default:
                    this.autenticado = true;
                    this.token = response;
                    sessionStorage.setItem('token', this.token);
                    sessionStorage.setItem('usuario', usuarioEnviar);
                    sessionStorage.setItem('pswd', passwordEnviar);
                    break;
            }
        }
        return response;
    }

    @action
    async muestraMensajeError(mensaje: string) {
        notification.warning({
            message: mensaje,
            style: { backgroundColor: '#ffffc3' },
            duration: 5
        });
    }

    @action
    cerrarSesion() {
        this.token = null;
        this.autenticado = false;
        sessionStorage.clear();
    }

    @action
    async validaTokenUsuario() {
        const response = await requestStore!.validaTokenUsuario();
        if (response) {
            if (response === 'error') {
                this.usuario = sessionStorage.getItem('usuario');
                this.password = sessionStorage.getItem('pswd');
                await this.getToken();
            }
        }
    }
}
export const tokenStore = new TokenStore();
export default TokenStore;
